import React, { Fragment } from 'react';
import { useLanguage } from '../../utils/useLanguage';
import { concat as cn } from '../../utils/concat';

const LanguageSwitch = ({ langs, className }) => {
    const langFromPathname = window.location.pathname.split('/')[1];
    const initialLang = langs.find((lang) => lang.key === langFromPathname)
        ? langFromPathname
        : 'de';

    const { lang: currentLang, setLang } = useLanguage(initialLang);

    return (
        <span className={cn(['language-toggle', className], ' ')}>
            {langs &&
                langs.map((item, i) => (
                    <Fragment key={i}>
                        {i > 0 && <span>{' | '}</span>}
                        {item.path ? (
                            <a
                                href={item.path}
                                className={cn(
                                    [
                                        'language-toggle__language',
                                        item.key === currentLang
                                            ? 'language-toggle__language--active notranslate'
                                            : 'notranslate',
                                    ],
                                    ' '
                                )}
                            >
                                {item.label || item.key}
                            </a>
                        ) : (
                            <button
                                style={{ cursor: 'pointer' }}
                                className={cn(
                                    [
                                        'language-toggle__language',
                                        item.key === currentLang
                                            ? 'language-toggle__language--active notranslate'
                                            : 'notranslate',
                                    ],
                                    ' '
                                )}
                                onClick={() => {
                                    setLang(item.key);
                                }}
                            >
                                {item.label || item.key}
                            </button>
                        )}
                    </Fragment>
                ))}
        </span>
    );
};

export default LanguageSwitch;



// WEBPACK FOOTER //
// ./src/components/shared/LanguageSwitch.jsx